/**
 * "Proatividade com orçamento: 1 aviso por abertura" (estudo de design). O que
 * aparece sozinho quando o app abre (o painel Hoje, a dica da conversa ao vivo,
 * a espiada da alça) disputa uma vaga só; quem perde espera a próxima abertura.
 */
let spent: string | null = null;

/** Pede a vaga desta abertura. Devolve true para o primeiro (ou para quem já a tem). */
export function claimOpeningNotice(id: string): boolean {
  if (spent === null) spent = id;
  return spent === id;
}

/** Só para os testes. */
export function resetOpeningNotice(): void {
  spent = null;
}
